import React, { Fragment, lazy, Suspense, useState } from 'react';
import { translationsModalEvents } from '../../../utils/events/translations.events';
import { Modal } from '@toluna-ui-toolkit/modals';
import { Loader } from '@toluna-ui-toolkit/loader';
import { LoaderWrapper, modalCustomStyles, TranslationsModalBody, TranslationsWrapper } from './Translations.style';
import { useEvent } from '../../common/hooks/useEvent.hook';
import { TranslationsModalConfig } from '../data/models';
const FederatedTranslations = lazy(() => import('translations/Root'));

export const Translations = () => {
    const [showTranslationsModal, setShowTranslationsModal] = useState(false);
    const [detail, setDetail] = useState<any>(null);

    const handleShowModal = (e: CustomEvent<TranslationsModalConfig>) => {
        setDetail(e.detail);
        setShowTranslationsModal(true);
    };

    const handleHideModal = () => {
        setShowTranslationsModal(false);
        setDetail(null);
    };

    useEvent({ name: translationsModalEvents.SHOW_TRANSLATIONS, handler: handleShowModal });
    useEvent({ name: translationsModalEvents.HIDE_TRANSLATIONS, handler: handleHideModal });

    if (!showTranslationsModal) {
        return <Fragment />;
    }

    const translationsProps = {
        config: {
            ...detail,
            baseUrl: window.ts?.globals?.TRANSLATIONS_BASE_URL,
            mediaServiceUrl: window.ts?.globals?.MEDIA_SERVICE_URL,
        },
        hideModal: handleHideModal,
    };

    const FallbackLoader = () => (
        <LoaderWrapper>
            <Loader />
        </LoaderWrapper>
    );

    return (
        <TranslationsWrapper id="translations-modal">
            <Modal customStyles={modalCustomStyles} showModal={showTranslationsModal}>
                <TranslationsModalBody>
                    <Suspense fallback={<FallbackLoader />}>
                        <FederatedTranslations {...translationsProps} />
                    </Suspense>
                </TranslationsModalBody>
            </Modal>
        </TranslationsWrapper>
    );
};

export default Translations;
